import { render, staticRenderFns } from "./EditInteractionModal.vue?vue&type=template&id=0d563fa3&scoped=true&"
import script from "./EditInteractionModal.vue?vue&type=script&lang=js&"
export * from "./EditInteractionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d563fa3",
  null
  
)

export default component.exports